import { useState, useEffect } from "react";
import { Input, Button, CardHeader } from "reactstrap";
import SearchTransactionDto from 'models/SearchTransactionDto';
import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import { setSearchDto } from "reducers/dto.slice";
import { isEqual, subDays, subMonths, startOfMonth, startOfDay } from "date-fns";
import Select, { SingleValue } from 'react-select';

const DataFilters = () => {

    const searchDto = useAppSelector(x => x.dtos.searchTransactionDto);
    const customer = useAppSelector(state => state.customers.selectedCustomer);
    const getMethod = useAppSelector(state => state.dtos.getMethod);

    const dispatch = useAppDispatch();

    const today = startOfDay(new Date());
    const pastMonth = subDays(today, 30);
    const past3Months = startOfMonth(subMonths(today, 2));

    const [searchTransactionDto, setSearchTransactionDto] = useState<SearchTransactionDto>(searchDto);

    const options = [
        { value: { startDate: pastMonth, endDate: today }, label: 'last 30 Days' },
        { value: { startDate: past3Months, endDate: today }, label: 'past 3 Months' }
    ];

    const currentYear = today.getFullYear();

    for (let i = currentYear; i >= 2021; i--) {
        options.push({ value: { startDate: new Date(i, 0, 1), endDate: new Date(i, 11, 31) }, label: i.toString() });
    };

    const [dateRange, setDateRange] = useState(options[0]);

    useEffect(() => {
        if (customer) {
            let sortDirection = "asc";
            if (searchDto.startDate &&
                searchDto.endDate) {
                if (isEqual(searchDto.startDate, pastMonth) && isEqual(searchDto.endDate, today)) {
                    setDateRange(options[0]);
                    sortDirection = "desc";
                } else if (isEqual(searchDto.startDate, past3Months)) {
                    setDateRange(options[1]);
                } else if (searchDto.startDate) {

                    let year = searchDto.startDate.getFullYear();
                    let initOption = options.map(x => x.label).indexOf(year.toString());
                    setDateRange(options[initOption]);
                }
                setSearchTransactionDto(s => { return { ...s, customerId: customer.customerId, sortDirection: sortDirection }; });
            }
        }
    },// eslint-disable-next-line
        [customer, searchDto, setDateRange]);

    useEffect(() => {
        setSearchTransactionDto(searchDto);
    },
        [searchDto]);

    if (!customer || !getMethod) return null;

    const onChange = (id: string, value: string) => {
        setSearchTransactionDto({ ...searchTransactionDto, [id]: value, page: 0 });
    };

    const onClick = () => {
        dispatch(setSearchDto(searchTransactionDto));
        dispatch(getMethod(searchTransactionDto));
    };

    const onSelectChange = (option: SingleValue<{ value: { startDate: Date, endDate: Date }; label: string; }>) => {
        setSearchTransactionDto({
            ...searchTransactionDto,
            startDate: option?.value.startDate,
            endDate: option?.value.endDate,
            page: 0,
            sortDirection: option?.label === "last 30 Days" ? "desc" : "asc"
        });

        setDateRange(option? option : options[0]);
    }

    return (
        <CardHeader className="d-flex justify-content-end align-items-center">
            <div className="bcd-select-175 me-3">
                <Select options={options}
                    defaultValue={dateRange}
                    onChange={onSelectChange}
                    isDisabled={!!searchTransactionDto.searchTerm}
                    aria-label="Date range filter"
                />
            </div>
            <div className="me-3">
                <Input
                    id="searchTerm"
                    placeholder="Search Term"
                    aria-label="Search transactions"
                    onChange={(e) => onChange(e.target.id, e.target.value)}
                    value={searchTransactionDto.searchTerm}
                    type="text"
                    className="bcd-lh"
                />
            </div>
            <div>
                <Button color="primary" type="submit" onClick={onClick}>
                    Search
                </Button>
            </div>
        </CardHeader>);
};

export default DataFilters;